export enum EmailEntityType {
    MAIL = "mail",
    SITE = "site",
    DOCUMENT = "document",
    DATE = "date",
    PLACE = "lieu",
}

type EmailEntityProps = {
    type: string;
    content: string;
};

export default class EmailEntity {
    type: string;

    content: string;

    constructor({ type, content }: EmailEntityProps) {
        this.type = type;
        this.content = content;
    }
}
